import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PlacardCatalogResponse } from "../api/models/placardCatalog";
import { ApiErrorCode, CONTINENTAL_REGIONS, COUNTRY_LANGUAGE, ServiceURLConstants } from "../constants/upplm.constants";
import { PLACARD_CATALOGS } from "../constants/upplm.constants.placardcatalog";
import { KeyValue } from "../interface/upplm.placard";
import { PlacardDetails } from "../interface/upplm.placardInformation";
import { TranslateDataPipe } from "../pipes/translation.pipe";
import { UpsCommonService } from "./upplm.common.service";

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()

export class PlacardCatalogService {

    constructor(private _translate: TranslateDataPipe,
        private _commonService: UpsCommonService,
        private _http: HttpClient) { }

    getPlacardSize(placardDetails: PlacardDetails): string {
        if (placardDetails.placardSize && placardDetails.placardSize.includes('Portrait')) {
            return placardDetails.placardSize.replace("Portrait", this._translate.transform('upplm.placarddetails.portrait'));
        } else if (placardDetails.placardSize && placardDetails.placardSize.includes('Landscape')) {
            return placardDetails.placardSize.replace("Landscape", this._translate.transform('upplm.placarddetails.landscape'))
        }
    }

    getPlacardSizeByKeyValue(placardSizes: KeyValue[]): KeyValue[] {
        let translatedPlacardSize: KeyValue[] = [];
        placardSizes.forEach(placardSize => {
            let keyvalue = new KeyValue();
            keyvalue.key = placardSize.key;

            if (placardSize.value.includes('Portrait')) {
                keyvalue.value = placardSize.value.replace("Portrait", this._translate.transform('upplm.placarddetails.portrait'));
            } else if (placardSize.value.includes('Landscape')) {
                keyvalue.value = placardSize.value.replace("Landscape", this._translate.transform('upplm.placarddetails.landscape'))
            }
            translatedPlacardSize.push(keyvalue);
        });
        return translatedPlacardSize;
    }

    async getPlacardCatalog(catalog: string, countryCode: string): Promise<PlacardCatalogResponse> {
        const url = this._commonService.createURL(`${ServiceURLConstants.GET_PLACARD_CATALOG}/${catalog}/${countryCode}`, ApiErrorCode.GET_PLACARD_CATALOG);
        return this._http.get<any>(url).toPromise();
    }

    async getPlacardSizeCatalogByCountryCode(countryCode: string): Promise<KeyValue[]> {
        let placardSizes: KeyValue[] = [];
        const response: PlacardCatalogResponse = await this.getPlacardCatalog(PLACARD_CATALOGS.PLACARD_SIZE, countryCode);
        if (!response.errors && response.catalogs.length > 0) {
            response.catalogs[0].elements.forEach(element => {
                let size = {
                    key: element.key,
                    value: element.value
                } as KeyValue;
                placardSizes.push(size);
            })
        }
        const region = COUNTRY_LANGUAGE.find(x => x.key === countryCode).region;
        return region === CONTINENTAL_REGIONS.NA ? this.getPlacardSizeByKeyValue(placardSizes) : placardSizes;
    }
}